import { Exchange } from 'urql';
import customScalarsExchange from './customScalarsExchange';
import scalars from '@watershed/shared-universal/graphql/scalars';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type BasicIntrospectionQuery = { __schema: any };

export default function scalarsExchange(
  schema: BasicIntrospectionQuery
): Exchange {
  return customScalarsExchange({
    schema,
    scalars,
  });
}
